export default __webpack_public_path__ + "static/media/default-user-icon.230ccea7.png";